import { useFetch } from "hooks/useFetch";
import NewWorkItem from "./NewWorkItem";

export default function NewWork() {
	const { data, isLoading, isError } = useFetch("/api/works");

	return (
		<div className="mt-32 flex flex-col md:flex-row items-start gap-6">
			<div className="w-full md:w-1/2">
				<div className="text-3xl md:text-7xl font-semibold">
					What I've been working on
				</div>
				<div className="mt-7 text-gray-500 text-lg md:text-xl">
					there’s my list of projects that i worked on
				</div>
			</div>
			{!isLoading && !isError && (
				<div className="w-full md:w-1/2">
					{data.map((item, i) => (
						<NewWorkItem
							key={i}
							link={item.link}
							name={item.name}
							type={item.type}
							desc={item.description}
							tech={item.tech.split(",")}
						/>
					))}
				</div>
			)}
		</div>
	);
}
